/* eslint-disable react/no-unescaped-entities */

import React, { useState } from "react";
import PropTypes from "prop-types";

import globalStyles from "globalStyles";
import { LineWrap, Section } from "components";
import { LinkedinIcon, EmailIcon, PhoneIcon } from "assets/images";
import ContactLink from "./ContactLink";
import personalInfo from "../../data/personalInfo";
import { useWindowSize } from "hooks";
import { K_MOBILE_SIZE } from "constants.js";

const ContactsSection = (props) => {
  const { anchorRef } = props;
  const [isFading, setIsFading] = useState(false);
  const { width } = useWindowSize();

  const personalInfoList = [
    personalInfo.linkedin,
    personalInfo.email,
    personalInfo.phone,
  ];
  // eslint-disable-next-line react/jsx-key
  const personalLinks = [<LinkedinIcon />, <EmailIcon />, <PhoneIcon />];
  const [selectedContactLinkIndex, setSelectedContactLinkIndex] = useState(1);
  const styles = {
    ...pcStyles,
    ...(width < K_MOBILE_SIZE ? mobileStyles : {}),
  };

  const selectLinkIndex = (index) => {
    setIsFading(true);
    setTimeout(() => {
      setSelectedContactLinkIndex(index);
      setIsFading(false);
    }, 350);
  };

  return (
    <Section style={styles.section} anchorRef={anchorRef}>
      <h1 style={styles.title}>LET'S GET IN TOUCH WITH ME!</h1>
      <h1 style={styles.name}>Jonathan Christopher Jakub</h1>
      <LineWrap>
        {personalInfoList.map((_, index) => (
          <ContactLink
            isSelected={selectedContactLinkIndex === index}
            onClick={() => selectLinkIndex(index)}
            key={index}
          >
            {personalLinks[index]}
          </ContactLink>
        ))}
      </LineWrap>
      <div style={styles.linkContainer}>
        <h3 style={{ ...styles.link, opacity: isFading ? 0 : 1 }}>
          {personalInfoList[selectedContactLinkIndex]}
        </h3>
      </div>
    </Section>
  );
};

const pcStyles = {
  section: {
    ...globalStyles.halfHeightSection,
    ...globalStyles.lightBackground,
    textAlign: "center",
    paddingTop: "2em",
    paddingBottom: "2em",
  },
  title: {
    ...globalStyles.textTitleSize,
    ...globalStyles.textDarkNavyColor,
    ...globalStyles.spaced,
  },
  link: {
    ...globalStyles.textTitleSize,
    ...globalStyles.spaced,
    ...globalStyles.textDarkNavyColor,
    transition: "opacity 0.5s",
  },
  name: {
    ...globalStyles.textDarkNavyColor,
    fontSize: "4rem",
  },
  linkContainer: {
    minHeight: "50px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    alignItems: "flex-end",
    marginTop: "1rem",
  },
};

const mobileStyles = {
  section: {
    ...globalStyles.halfHeightSection,
    ...globalStyles.lightBackground,
    textAlign: "center",
    paddingTop: "5em",
    paddingBottom: "2em",
  },
  title: {
    ...globalStyles.textSmallSize,
    ...globalStyles.textDarkNavyColor,
    ...globalStyles.spaced,
  },
  link: {
    ...globalStyles.textDarkNavyColor,
    ...globalStyles.spaced,
    transition: "opacity 0.5s",
    fontSize: "0.9rem",
    marginTop: "0.5rem",
    minHeight: "4rem",
  },
  name: {
    ...globalStyles.textDarkNavyColor,
    fontSize: "2.5rem",
  },
};

ContactsSection.propTypes = {
  anchorRef: PropTypes.shape().isRequired,
};

export default ContactsSection;
